import { api } from './index';

const prefix = '/api/basic_info/company/';

export function apiSelectCompany() {
	return api.get(prefix + 'selectCompany');
}

export function apiUpdateCompany(param) {
	param.mode = 'update';
	return api.post(prefix + 'submitCompany', param);
}
